import { TypeSettingsWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';

type TSettings = {
    [key: string]: string | TSettings;
};

/**
 * Creates a settings object from an array of settings entries.
 * @param settings - An optional array of settings entries.
 * @returns The settings object.
 */
const createSettingsObject = (settings?: TypeSettingsWithoutUnresolvableLinksResponse[]) => {
    return (
        settings
            ?.filter((setting) => setting)
            .reduce((acc: TSettings, setting) => {
                if (setting?.fields?.key && setting?.fields?.value) {
                    const sKey = setting.fields.key;
                    const sValue = setting.fields.value;
                    const keyParts = sKey.split('.'); // Split key by dot to create nested object
                    if (keyParts.length > 1) {
                        const [parentKey, childKey] = keyParts; // Destructure parent and child key
                        acc[parentKey] = acc[parentKey] || {}; // Initialize parent key if it doesn't exist
                        (acc[parentKey] as TSettings)[childKey] = sValue; // Assign value to child key
                    } else {
                        acc[sKey] = sValue;
                    }
                }
                return acc;
            }, {}) ?? {}
    );
};

export default createSettingsObject;
